module.exports = __webpack_public_path__ + "img/Registration.ffcdbe95.png";